export default {
  get_cert_with_query: "certificate/getCertificateWithQueryId/%s",
};
